// extracted by mini-css-extract-plugin
module.exports = {"icon":"InfoIcon-module__icon___ROZn3"};